import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmComponent } from './confirm/confirm.component';
import { MatButtonModule } from '@angular/material/button';
@NgModule({
  declarations: [ConfirmComponent],
  imports: [CommonModule, MatButtonModule]
})
export class SupportModule {}
